export default {
  pdfReports: 'PDF_REPORTS',
  pdfEntityReports: 'PDF_ENTITY_REPORTS',
  setLoading: 'PDF_REPORTS_SET_LOADING'
};
